'use client';

import React, { memo } from 'react';
import { Footer } from '@havenengineering/module-shared-haven-ui-layout/dist/components/Footer';
import { analytics } from '../../../../helpers/gtm/analytics';

const MainFooter = () => {
  return <Footer showNavigation={false} analytics={analytics} />;
};

export const DefaultFooter = memo(MainFooter);
